import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './login_types.2';

export function getIsLoggedIn(variable?: null, options?: GqlRequestOptions) {
  const query = 'query GetIsLoggedIn { is_logged_in: isLoggedIn }';
  return gql_request<types.GetIsLoggedIn, null>('GetIsLoggedIn', query, variable, { use_consumer: true, ...options });
}

